import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFolder, IFolderInput } from '@modules/management/modules/folders/model/folders.interfaces';

import { FoldersService } from '../../services/folders.service';

import * as Mark from 'mark.js';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-folder-item',
  templateUrl: './folder-item.component.html',
  styleUrls: ['./folder-item.component.scss'],
})
export class FolderItemComponent implements AfterViewInit {
  @Input() folderItem: IFolder;
  @Input() mainUrl: string;
  @Input() searchWord?: string;
  @Input() customIcon?: IFolderInput['icon'];
  @Input() disableClick?: boolean;
  @Output() folderSelect: EventEmitter<void> = new EventEmitter<void>();

  public itemID = `folder_${uuidv4()}`;

  constructor(private foldersService: FoldersService) {}

  onClickRow(): void {
    if (this.disableClick) {
      return;
    }
    this.foldersService.goToFolder(this.mainUrl, this.folderItem.folderID);
  }

  ngAfterViewInit(): void {
    if (this.searchWord) {
      this.highlightTitle();
    }
  }

  public onFolderSelect(): void {
    this.folderSelect.emit();
  }

  private highlightTitle(): void {
    const instance = new Mark(document.querySelector(`#${this.itemID}`));

    if (instance) {
      instance.unmark();

      if (this.searchWord) {
        instance.mark(this.searchWord, {element: 'span', className: 'highlight'});
      }
    }
  }
}
